import { COMMON_PDT_CONSTANTS } from '../CommonPdtConstants';
import { eventValue } from '.';
import { getV2PDTclientSchema } from '../../../RailsAbConfig';

const isPdtClientSchemaV2 = getV2PDTclientSchema();

/** Please update this schema ID and schema Name when new schema is created */

const PDT_SCHEMA_ID_V2 = 173469; // Updating to Version 6 from 5
const PDT_SCHEMA_ID_DEFAULT = 167325; // Updating to Version 10 now from 9
const PDT_SCHEMA_NAME_V2 = 'mmt_rails_b2c_pdt_client_logging_v2';
const PDT_SCHEMA_NAME_DEFAULT = 'mmt_rails_b2c_pdt_client_logging';

export const PDT_SCHEMA_ID = isPdtClientSchemaV2 ? PDT_SCHEMA_ID_DEFAULT : PDT_SCHEMA_ID_V2;
export const PDT_SCHEMA_NAME = isPdtClientSchemaV2 ? PDT_SCHEMA_NAME_DEFAULT :PDT_SCHEMA_NAME_V2 ;


export const PDT_SCHEMA_MEALS_ID = 164321;
export const PDT_SCHEMA_MEALS_NAME = 'mmt_rails_meals_b2c_pdt_client_logging';

export const pdtCtEventValues: {
  EXPANDED: eventValue;
  INTERACTED: eventValue;
  TRAIN: eventValue;
  BUS: eventValue;
} = {
  EXPANDED: 'EXPANDED',
  INTERACTED: 'INTERACTED',
  TRAIN: 'TRAIN',
  BUS: 'BUS',
};

export const CT_PDT_EVENTS = {
  EXPANDED: {
    event_name: COMMON_PDT_CONSTANTS.PRODUCT_CLICKED_EVENT,
    event_type: COMMON_PDT_CONSTANTS.ACTION_EVENT,
    event_value: pdtCtEventValues.EXPANDED,
  },
  INTERACTED: {
    event_name: COMMON_PDT_CONSTANTS.PRODUCT_CLICKED_EVENT,
    event_type: COMMON_PDT_CONSTANTS.ACTION_EVENT,
    event_value: pdtCtEventValues.INTERACTED,
  },
  TRAIN: {
    event_name: COMMON_PDT_CONSTANTS.PRODUCT_CLICKED_EVENT,
    event_type: COMMON_PDT_CONSTANTS.ACTION_EVENT,
    event_value: pdtCtEventValues.TRAIN,
  },
  BUS: {
    event_name: COMMON_PDT_CONSTANTS.PRODUCT_CLICKED_EVENT,
    event_type: COMMON_PDT_CONSTANTS.ACTION_EVENT,
    event_value: pdtCtEventValues.BUS,
  },
};

export const LANDING_PDT_EVENTS = {
  LANDING_LOAD: {
    event_name: COMMON_PDT_CONSTANTS.PAGE_LOAD_EVENT,
    event_type: COMMON_PDT_CONSTANTS.LIFE_CYCLE_EVENT,
    event_value: 'landing_load',
  },
  LANDING_BACK_CLICK: {
    event_name: COMMON_PDT_CONSTANTS.BUTTON_CLICKED,
    event_type: COMMON_PDT_CONSTANTS.ACTION_EVENT,
    event_value: 'landing_back_clicked',
  },
  SEARCH_CLICK: {
    event_name: COMMON_PDT_CONSTANTS.BUTTON_CLICKED,
    event_type: COMMON_PDT_CONSTANTS.ACTION_EVENT,
    event_value: 'search_clicked',
  },
  AUTOSUGGESTION_CLICK: {
    event_name: COMMON_PDT_CONSTANTS.BUTTON_CLICKED,
    event_type: COMMON_PDT_CONSTANTS.ACTION_EVENT,
    event_value: 'autosuggestion_clicked',
  },
  LANDING_FREE_CANCELLATION_OPTED: {
    event_name: COMMON_PDT_CONSTANTS.BUTTON_CLICKED,
    event_type: COMMON_PDT_CONSTANTS.ACTION_EVENT,
    event_value: 'landing_free_cancellation_opted',
  },
  LANDING_FREE_CANCELLATION_DESELECTED: {
    event_name: COMMON_PDT_CONSTANTS.BUTTON_CLICKED,
    event_type: COMMON_PDT_CONSTANTS.ACTION_EVENT,
    event_value: 'landing_free_cancellation_deselected',
  },
  LANDING_DATE_BAR_CLICK: {
    event_name: COMMON_PDT_CONSTANTS.BUTTON_CLICKED,
    event_type: COMMON_PDT_CONSTANTS.ACTION_EVENT,
    event_value: 'landing_date_bar_clicked',
  },
  LANDING_DATE_BAR_TOMORROW_CLICK: {
    event_name: COMMON_PDT_CONSTANTS.BUTTON_CLICKED,
    event_type: COMMON_PDT_CONSTANTS.ACTION_EVENT,
    event_value: 'landing_date_bar_tomorrow_clicked',
  },
  LANDING_DATE_BAR_DAY_AFTER_CLICK: {
    event_name: COMMON_PDT_CONSTANTS.BUTTON_CLICKED,
    event_type: COMMON_PDT_CONSTANTS.ACTION_EVENT,
    event_value: 'landing_date_bar_day_after_clicked',
  },
};
export const SEM_LANDING_PAGE_EVENTS: unknown = {
  PAGE_LOAD: {
    event_name: COMMON_PDT_CONSTANTS.PAGE_LOAD_EVENT,
    event_type: COMMON_PDT_CONSTANTS.LIFE_CYCLE_EVENT,
    event_value: 'sem_landing_page_load',
  },
};

export const LANDING_PDT_CLICK_EVENTS = {
  SEARCH_CLICK: 'SEARCH_CLICK',
  LANDING_BACK_CLICK: 'LANDING_BACK_CLICK',
  AUTOSUGGESTION_CLICK: 'AUTOSUGGESTION_CLICK',
  LANDING_FREE_CANCELLATION_OPTED: 'LANDING_FREE_CANCELLATION_OPTED',
  LANDING_FREE_CANCELLATION_DESELECTED: 'LANDING_FREE_CANCELLATION_DESELECTED',
  LANDING_DATE_BAR_CLICK: 'LANDING_DATE_BAR_CLICK',
  LANDING_DATE_BAR_TOMORROW_CLICK: 'LANDING_DATE_BAR_TOMORROW_CLICK',
  LANDING_DATE_BAR_DAY_AFTER_CLICK: 'LANDING_DATE_BAR_DAY_AFTER_CLICK',
};

export const LISTING_PDT_EVENTS = {
  LISTING_LOAD: {
    event_name: COMMON_PDT_CONSTANTS.PAGE_LOAD_EVENT,
    event_type: COMMON_PDT_CONSTANTS.LIFE_CYCLE_EVENT,
    event_value: 'funnel:rails:listing',
  },
};

export const LISTING_PDT_CLICK_EVENTS = {
  BACK_CLICK: 'listing_back_click',
  EDIT_WIDGET_CLICK: 'edit_widget_click',
  TAB_CLICK: 'tab_click',
  LISTING_BANNER_CLICK: 'listing_banner_click',
  LISTING_DATE_CHANGE_CLICK: 'listing_date_change_click',
  NEARBY_DATE_CLICK: 'nearby_date_click',
  QUICK_FILTER_CLICK: 'quick_filter_click',
  SORT_AND_FILTER_APPLY_CLICK: 'sort_and_filter_apply_click',
  CLEAR_ALL_FILTERS_LISTING_CLICK: 'clear_all_filters_listing_click',
  CHANGE_FILTERS_LISTING_CLICK: 'change_filters_listing_click',
  FILTERS_PAGE_CROSS_CLICK: 'filters_page_cross_click',
  FILTERS_PAGE_CLEAR_ALL_CLICK: 'filters_page_clear_all_click',
  LISTING_SORT_AND_FILTER_ICON_CLICK: 'listing_sort_and_filter_icon_click',
  TRAIN_CARD_CLICK: 'train_card_click',
  AVAILABILITY_FILTER_CLICK: 'availability_filter_click',
  FILTERS_BUTTON_CLICK: 'filters_button_click',
};

export const THANK_YOU_PDT_EVENTS = {
  THANKYOU_LOAD: {
    event_name: COMMON_PDT_CONSTANTS.PAGE_LOAD_EVENT,
    event_type: COMMON_PDT_CONSTANTS.LIFE_CYCLE_EVENT,
    event_value: 'funnel:rails:thankyou',
  },
  BOOK_RETURN_TICKET_CLICK: {
    event_name: COMMON_PDT_CONSTANTS.BUTTON_CLICKED,
    event_type: COMMON_PDT_CONSTANTS.ACTION_EVENT,
    event_value: 'book_return_ticket_clicked',
  },
  MANAGE_BOOKING_CLICK: {
    event_name: COMMON_PDT_CONSTANTS.BUTTON_CLICKED,
    event_type: COMMON_PDT_CONSTANTS.ACTION_EVENT,
    event_value: 'manage_booking_clicked',
  },
  THANK_YOU_ORDER_MEAL_CLICK: {
    event_name: COMMON_PDT_CONSTANTS.BUTTON_CLICKED,
    event_type: COMMON_PDT_CONSTANTS.ACTION_EVENT,
    event_value: 'thank_you_order_meal_click',
  },
  THANK_YOU_HOME_ICOON_CLICK: {
    event_name: COMMON_PDT_CONSTANTS.BUTTON_CLICKED,
    event_type: COMMON_PDT_CONSTANTS.ACTION_EVENT,
    event_value: 'thank_you_home_icon_click',
  },
  FEED_BACK_SURVEY_SUBMIT_CLICK: {
    event_name: COMMON_PDT_CONSTANTS.BUTTON_CLICKED,
    event_type: COMMON_PDT_CONSTANTS.ACTION_EVENT,
    event_value: 'feed_back_survey_submit_click',
  },
};

export const THANK_YOU_PDT_CLICK_EVENTS = {
  BOOK_RETURN_TICKET_CLICK: 'BOOK_RETURN_TICKET_CLICK',
  MANAGE_BOOKING_CLICK: 'MANAGE_BOOKING_CLICK',
  THANK_YOU_ORDER_MEAL_CLICK: 'THANK_YOU_ORDER_MEAL_CLICK',
  THANK_YOU_HOME_ICOON_CLICK: 'THANK_YOU_HOME_ICOON_CLICK',
  FEED_BACK_SURVEY_SUBMIT_CLICK: 'FEED_BACK_SURVEY_SUBMIT_CLICK',
};

export const REVIEW_PAGE_PDT_EVENTS = {
  REVIEW_PAGE_LOAD: {
    event_name: COMMON_PDT_CONSTANTS.PAGE_LOAD_EVENT,
    event_type: COMMON_PDT_CONSTANTS.LIFE_CYCLE_EVENT,
    event_value: 'funnel:rails:review',
  },
  REVIEW_PAGE_PAY_NOW_CLICKED: {
    event_name: COMMON_PDT_CONSTANTS.BUTTON_CLICKED,
    event_type: COMMON_PDT_CONSTANTS.ACTION_EVENT,
    event_value: 'review_page_pay_now_clicked',
  },
};

export const REVIEW_PAGE_CLICK_EVENTS = {
  REVIEW_PAGE_PAY_NOW_CLICKED: 'REVIEW_PAGE_PAY_NOW_CLICKED',
};

export const TRAVELLER_CLICK_EVENTS = {
  TRAVELLERS_ON_REVIEW_CLICK: 'TRAVELLERS_ON_REVIEW_CLICK',
  GET_NEW_IRCTC_PASSWORD: 'GET_NEW_IRCTC_PASSWORD',
  IRCTC_WHY_REQUIRED_CLICKED: 'IRCTC_WHY_REQUIRED_CLICKED',
  IRCTC_USERNAME_CHANGE_CLICKED: 'IRCTC_USERNAME_CHANGE_CLICKED',
  COUPON_APPLY_CLICKED: 'COUPON_APPLY_CLICKED',
  COUPON_REMOVE_CLICKED: 'COUPON_REMOVE_CLICKED',
  ADDITIONAL_PREFERENCES_CLICKED: 'ADDITIONAL_PREFERENCES_CLICKED',
  TRAVELLERS_ON_REVIEW_BACK_CLICK: 'TRAVELLERS_ON_REVIEW_BACK_CLICK',
  BOOK_CONFIRMED_BERTHS: 'BOOK_CONFIRMED_BERTHS',
  CONSIDER_AUTO_UPGRADATION: 'CONSIDER_AUTO_UPGRADATION',
  NO_PREFERENCE: 'NO_PREFERENCE',
  SAME_COACH_PREFERENCE: 'SAME_COACH_PREFERENCE',
  ADDPREF_ONE_LOWER_BERTH: 'ADDPREF_ONE_LOWER_BERTH',
  ADDPREF_TWO_LOWER_BERTH: 'ADDPREF_TWO_LOWER_BERTH',
  SEAT_LOCK_WIDGET_PAY_PARTIAL: 'SEAT_LOCK_WIDGET_PAY_PARTIAL',
  SEAT_LOCK_WIDGET_PAY_FULL: 'SEAT_LOCK_WIDGET_PAY_FULL',
  SEAT_LOCK_BOTTOM_SHEET_PAY_PARTIAL: 'SEAT_LOCK_BOTTOM_SHEET_PAY_PARTIAL',
  SEAT_LOCK_BOTTOM_SHEET_PAY_FULL: 'SEAT_LOCK_BOTTOM_SHEET_PAY_FULL',
  FC_TG_WIDGET: 'FC_TG_WIDGET',
  FREE_CANCELLATION_BOTTOM_SHEET: 'FREE_CANCELLATION_BOTTOM_SHEET',
  FREE_CANCELLATION_OPTED_BOTTOM_SHEET: 'FREE_CANCELLATION_OPTED_BOTTOM_SHEET',
  FREE_CANCELLATION_OPTED: 'FREE_CANCELLATION_OPTED',
  FREE_CANCELLATION_DESELECTED: 'FREE_CANCELLATION_DESELECTED',
  TRIP_GUARANTEE_OPTED: 'TRIP_GUARANTEE_OPTED',
  TRIP_GUARANTEE_DESELECTED: 'TRIP_GUARANTEE_DESELECTED',
  AVAIL_DEPLETION_BOTTOM_SHEET: 'AVAIL_DEPLETION_BOTTOM_SHEET',
  AVAILABILITY_SUBSCRIPTION_BOTTOM_SHEET: 'AVAILABILITY_SUBSCRIPTION_BOTTOM_SHEET',
  RESISTANCE_SIMPLE_BOTTOM_SHEET: 'RESISTANCE_SIMPLE_BOTTOM_SHEET',
  REVIEW_ERROR_BOTTOM_SHEET: 'REVIEW_ERROR_BOTTOM_SHEET',
  REVIEW_DOWNTIME_BOTTOM_SHEET: 'REVIEW_DOWNTIME_BOTTOM_SHEET',
  TRAVELLER_RESET_PWD_BS_LOADED: 'TRAVELLER_RESET_PWD_BS_LOADED',
  TRAVELLER_RESET_PWD_AFTER_ERROR: 'TRAVELLER_RESET_PWD_AFTER_ERROR',
  TRAVELLER_CLOSE_PWD_AFTER_ERROR: 'TRAVELLER_CLOSE_PWD_AFTER_ERROR',
  TRAVELLER_RECEIVE_PWD_AFTER_ERROR: 'TRAVELLER_RECEIVE_PWD_AFTER_ERROR',
  TRAVELLER_CROSS_INPUT_AFTER_ERROR: 'TRAVELLER_CROSS_INPUT_AFTER_ERROR',
  TRAVELLER_GO_BACK_AFTER_ERROR: 'TRAVELLER_GO_BACK_AFTER_ERROR',
  TRIP_GUARANTEE_BOTTOM_SHEET: 'TRIP_GUARANTEE_BOTTOM_SHEET',
  TRAVELLER_BOARDING_STATION_CHANGE_CLICK: 'TRAVELLER_BOARDING_STATION_CHANGE_CLICK',
  TRAVELLER_BOARDING_STATION_CHANGE_SAVED: 'TRAVELLER_BOARDING_STATION_CHANGE_SAVED',
};

export const TRAVELLER_PDT_EVENTS = {
  TRAVELLERS_LOAD: {
    event_name: COMMON_PDT_CONSTANTS.PAGE_LOAD_EVENT,
    event_type: COMMON_PDT_CONSTANTS.LIFE_CYCLE_EVENT,
    event_value: 'funnel:rails:travellers',
  },
  TRAVELLERS_ON_REVIEW_CLICK: {
    event_name: COMMON_PDT_CONSTANTS.BUTTON_CLICKED,
    event_type: COMMON_PDT_CONSTANTS.ACTION_EVENT,
    event_value: 'review_clicked',
  },
  TRAVELLERS_ON_REVIEW_BACK_CLICK: {
    event_name: COMMON_PDT_CONSTANTS.BUTTON_CLICKED,
    event_type: COMMON_PDT_CONSTANTS.ACTION_EVENT,
    event_value: 'review_back_clicked',
  },
  BOOK_CONFIRMED_BERTHS: {
    event_name: COMMON_PDT_CONSTANTS.BUTTON_CLICKED,
    event_type: COMMON_PDT_CONSTANTS.ACTION_EVENT,
    event_value: 'book_confirmed_berths_clicked',
  },
  CONSIDER_AUTO_UPGRADATION: {
    event_name: COMMON_PDT_CONSTANTS.BUTTON_CLICKED,
    event_type: COMMON_PDT_CONSTANTS.ACTION_EVENT,
    event_value: 'consider_auto_upgradation_clicked',
  },
  NO_PREFERENCE: {
    event_name: COMMON_PDT_CONSTANTS.BUTTON_CLICKED,
    event_type: COMMON_PDT_CONSTANTS.ACTION_EVENT,
    event_value: 'no_preference_clicked',
  },
  SAME_COACH_PREFERENCE: {
    event_name: COMMON_PDT_CONSTANTS.BUTTON_CLICKED,
    event_type: COMMON_PDT_CONSTANTS.ACTION_EVENT,
    event_value: 'same_coach_preference_clicked',
  },
  ADDPREF_ONE_LOWER_BERTH: {
    event_name: COMMON_PDT_CONSTANTS.BUTTON_CLICKED,
    event_type: COMMON_PDT_CONSTANTS.ACTION_EVENT,
    event_value: 'addpref_one_lower_berth_clicked',
  },
  ADDPREF_TWO_LOWER_BERTH: {
    event_name: COMMON_PDT_CONSTANTS.BUTTON_CLICKED,
    event_type: COMMON_PDT_CONSTANTS.ACTION_EVENT,
    event_value: 'addpref_two_lower_berth_clicked',
  },
  GET_NEW_IRCTC_PASSWORD: {
    event_name: COMMON_PDT_CONSTANTS.BUTTON_CLICKED,
    event_type: COMMON_PDT_CONSTANTS.ACTION_EVENT,
    event_value: 'get_new_irctc_password_clicked',
  },
  IRCTC_WHY_REQUIRED_CLICKED: {
    event_name: COMMON_PDT_CONSTANTS.BUTTON_CLICKED,
    event_type: COMMON_PDT_CONSTANTS.ACTION_EVENT,
    event_value: 'irctc_why_required_clicked',
  },
  IRCTC_USERNAME_CHANGE_CLICKED: {
    event_name: COMMON_PDT_CONSTANTS.BUTTON_CLICKED,
    event_type: COMMON_PDT_CONSTANTS.ACTION_EVENT,
    event_value: 'irctc_username_change_clicked',
  },
  COUPON_APPLY_CLICKED: {
    event_name: COMMON_PDT_CONSTANTS.BUTTON_CLICKED,
    event_type: COMMON_PDT_CONSTANTS.ACTION_EVENT,
    event_value: 'coupon_apply_clicked',
  },
  COUPON_REMOVE_CLICKED: {
    event_name: COMMON_PDT_CONSTANTS.BUTTON_CLICKED,
    event_type: COMMON_PDT_CONSTANTS.ACTION_EVENT,
    event_value: 'coupon_remove_clicked',
  },
  ADDITIONAL_PREFERENCES_CLICKED: {
    event_name: COMMON_PDT_CONSTANTS.BUTTON_CLICKED,
    event_type: COMMON_PDT_CONSTANTS.ACTION_EVENT,
    event_value: 'additional_preferences_clicked',
  },
  SEAT_LOCK_WIDGET_PAY_PARTIAL: {
    event_name: COMMON_PDT_CONSTANTS.BUTTON_CLICKED,
    event_type: COMMON_PDT_CONSTANTS.ACTION_EVENT,
    event_value: 'seat_lock_widget_pay_partial_clicked',
  },
  SEAT_LOCK_WIDGET_PAY_FULL: {
    event_name: COMMON_PDT_CONSTANTS.BUTTON_CLICKED,
    event_type: COMMON_PDT_CONSTANTS.ACTION_EVENT,
    event_value: 'seat_lock_widget_pay_full_clicked',
  },
  SEAT_LOCK_BOTTOM_SHEET_PAY_PARTIAL: {
    event_name: COMMON_PDT_CONSTANTS.BUTTON_CLICKED,
    event_type: COMMON_PDT_CONSTANTS.ACTION_EVENT,
    event_value: 'seat_lock_bottom_sheet_pay_partial_clicked',
  },
  SEAT_LOCK_BOTTOM_SHEET_PAY_FULL: {
    event_name: COMMON_PDT_CONSTANTS.BUTTON_CLICKED,
    event_type: COMMON_PDT_CONSTANTS.ACTION_EVENT,
    event_value: 'seat_lock_bottom_sheet_pay_full_clicked',
  },
  FC_TG_WIDGET: {
    event_name: COMMON_PDT_CONSTANTS.BUTTON_CLICKED,
    event_type: COMMON_PDT_CONSTANTS.ACTION_EVENT,
    event_value: 'fc_tg_widget_clicked',
  },
  FREE_CANCELLATION_BOTTOM_SHEET: {
    event_name: COMMON_PDT_CONSTANTS.PAGE_LOAD_EVENT,
    event_type: COMMON_PDT_CONSTANTS.ACTION_EVENT,
    event_value: 'free_cancellation_bottom_sheet_shown',
  },
  FREE_CANCELLATION_OPTED_BOTTOM_SHEET: {
    event_name: COMMON_PDT_CONSTANTS.BUTTON_CLICKED,
    event_type: COMMON_PDT_CONSTANTS.ACTION_EVENT,
    event_value: 'free_cancellation_opted_from_bottom_sheet',
  },
  FREE_CANCELLATION_OPTED: {
    event_name: COMMON_PDT_CONSTANTS.BUTTON_CLICKED,
    event_type: COMMON_PDT_CONSTANTS.ACTION_EVENT,
    event_value: 'free_cancellation_opted',
  },
  FREE_CANCELLATION_DESELECTED: {
    event_name: COMMON_PDT_CONSTANTS.BUTTON_CLICKED,
    event_type: COMMON_PDT_CONSTANTS.ACTION_EVENT,
    event_value: 'free_cancellation_deselected',
  },
  TRIP_GUARANTEE_OPTED: {
    event_name: COMMON_PDT_CONSTANTS.BUTTON_CLICKED,
    event_type: COMMON_PDT_CONSTANTS.ACTION_EVENT,
    event_value: 'trip_guarantee_opted',
  },
  TRIP_GUARANTEE_DESELECTED: {
    event_name: COMMON_PDT_CONSTANTS.BUTTON_CLICKED,
    event_type: COMMON_PDT_CONSTANTS.ACTION_EVENT,
    event_value: 'trip_guarantee_deselected',
  },
  AVAIL_DEPLETION_BOTTOM_SHEET: {
    event_name: COMMON_PDT_CONSTANTS.PAGE_LOAD_EVENT,
    event_type: COMMON_PDT_CONSTANTS.ACTION_EVENT,
    event_value: 'avail_depletion_bottom_sheet_shown',
  },
  AVAILABILITY_SUBSCRIPTION_BOTTOM_SHEET: {
    event_name: COMMON_PDT_CONSTANTS.PAGE_LOAD_EVENT,
    event_type: COMMON_PDT_CONSTANTS.ACTION_EVENT,
    event_value: 'availability_subscription_bottom_sheet_shown',
  },
  RESISTANCE_SIMPLE_BOTTOM_SHEET: {
    event_name: COMMON_PDT_CONSTANTS.PAGE_LOAD_EVENT,
    event_type: COMMON_PDT_CONSTANTS.ACTION_EVENT,
    event_value: 'resistance_simple_bottom_sheet_shown',
  },
  REVIEW_ERROR_BOTTOM_SHEET: {
    event_name: COMMON_PDT_CONSTANTS.PAGE_LOAD_EVENT,
    event_type: COMMON_PDT_CONSTANTS.ACTION_EVENT,
    event_value: 'review_error_bottom_sheet_shown',
  },
  REVIEW_DOWNTIME_BOTTOM_SHEET: {
    event_name: COMMON_PDT_CONSTANTS.PAGE_LOAD_EVENT,
    event_type: COMMON_PDT_CONSTANTS.ACTION_EVENT,
    event_value: 'review_downtime_bottom_sheet_shown',
  },
  TRIP_GUARANTEE_BOTTOM_SHEET: {
    event_name: COMMON_PDT_CONSTANTS.PAGE_LOAD_EVENT,
    event_type: COMMON_PDT_CONSTANTS.ACTION_EVENT,
    event_value: 'trip_guarantee_bottom_sheet_shown',
  },
  TRAVELLER_BOARDING_STATION_CHANGE_CLICK: {
    event_name: COMMON_PDT_CONSTANTS.BUTTON_CLICKED,
    event_type: COMMON_PDT_CONSTANTS.ACTION_EVENT,
    event_value: 'boarding_station_clicked',
  },
  TRAVELLER_BOARDING_STATION_CHANGE_SAVED: {
    event_name: COMMON_PDT_CONSTANTS.BUTTON_CLICKED,
    event_type: COMMON_PDT_CONSTANTS.ACTION_EVENT,
    event_value: 'boarding_station_selected',
  },
  TRAVELLER_RESET_PWD_BS_LOADED: {
    event_name: COMMON_PDT_CONSTANTS.PAGE_LOAD_EVENT,
    event_type: COMMON_PDT_CONSTANTS.ACTION_EVENT,
    event_value: 'traveller_reset_pwd_bs_loaded',
  },
  TRAVELLER_RESET_PWD_AFTER_ERROR: {
    event_name: COMMON_PDT_CONSTANTS.BUTTON_CLICKED,
    event_type: COMMON_PDT_CONSTANTS.ACTION_EVENT,
    event_value: 'traveller_reset_pwd_after_error',
  },
  TRAVELLER_CLOSE_PWD_AFTER_ERROR: {
    event_name: COMMON_PDT_CONSTANTS.BUTTON_CLICKED,
    event_type: COMMON_PDT_CONSTANTS.ACTION_EVENT,
    event_value: 'traveller_close_pwd_after_error',
  },
  TRAVELLER_RECEIVE_PWD_AFTER_ERROR: {
    event_name: COMMON_PDT_CONSTANTS.BUTTON_CLICKED,
    event_type: COMMON_PDT_CONSTANTS.ACTION_EVENT,
    event_value: 'traveller_receive_pwd_after_error',
  },
  TRAVELLER_CROSS_INPUT_AFTER_ERROR: {
    event_name: COMMON_PDT_CONSTANTS.BUTTON_CLICKED,
    event_type: COMMON_PDT_CONSTANTS.ACTION_EVENT,
    event_value: 'traveller_cross_input_after_error',
  },
  TRAVELLER_GO_BACK_AFTER_ERROR: {
    event_name: COMMON_PDT_CONSTANTS.BUTTON_CLICKED,
    event_type: COMMON_PDT_CONSTANTS.ACTION_EVENT,
    event_value: 'traveller_go_back_after_error',
  },
};

export const IRCTC_USERNAME_CREATION_FORM_EVENTS = {
  SUCCESSFULLY_CREATED: {
    event_name: COMMON_PDT_CONSTANTS.PAGE_LOAD_EVENT,
    event_type: COMMON_PDT_CONSTANTS.ACTION_EVENT,
    event_value: 'irctc_username_created_successfully',
  },
};